import { toast } from "src/hooks/useToast";
export const validateInvoiceProducts = (products: any[]): boolean => {
    let isValid = true;
    products.forEach((item) => {
        const { item_description, item_code, inv_mrp, ptr, batch_no } = item;
        if (
            batch_no === undefined ||
            batch_no === null ||
            batch_no === "" ||
            batch_no === "undefined"
        ) {
            toast({
                description: `Item "${item_description}" has an invalid batch_no.`,
                variant: "destructive",
            });
            isValid = false;
        }
        if (
            item_code === undefined ||
            item_code === null ||
            item_code === "" ||
            item_code === "undefined"
        ) {
            toast({
                description: `Item "${item_description}" has an invalid item_code.`,
                variant: "destructive",
            });
            isValid = false;
        }
        if (
            inv_mrp === undefined ||
            inv_mrp === null ||
            inv_mrp === "" ||
            inv_mrp === "undefined" ||
            Number(inv_mrp) === 0
        ) {
            toast({
                description: `Item "${item_description}" has an invalid inv_mrp.`,
                variant: "destructive",
            });
            isValid = false;
        }
        if (
            ptr === undefined ||
            ptr === null ||
            Number(ptr) === 0
        ) {
            toast({
                description: `Item "${item_description}" has an invalid ptr.`,
                variant: "destructive",
            });
            isValid = false;
        }
    });
    return isValid;
};

export function generateShortUniqueKey(length = 7) {
    const base36Time = Date.now().toString(36).slice(-3); // last 3 chars from timestamp
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    let randomPart = '';

    for (let i = 0; i < length - base36Time.length; i++) {
        randomPart += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return (base36Time + randomPart).slice(0, length); // ensure total length
}